export class Country {
  id?: number;
  active?: boolean;
  formatActive?: string;
  code?: string;
  currencyCode?: string;
  description?: string;
  name?: string;
  Remarks?: string;
  createdBy?: string;
  createdDate?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
}
